var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-link",attrs:{"to":{name: 'Root'}}},[_c('img',{staticClass:"header-logo",attrs:{"src":require("@/assets/header-logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }